import type { i18n } from "i18next";

export function registerI18nFormatters(instance: i18n) {
  const { formatter } = instance.services;
  if (!formatter) {
    throw new Error("i18n formatter service is not available");
  }

  formatter.add("signed", (value) => {
    const num = Number(value);
    return num > 0 ? `+${num}` : `${num}`;
  });
}
